import type { SerializedError } from '@reduxjs/toolkit';
import type { FetchBaseQueryError } from '@reduxjs/toolkit/query';
import { t } from 'i18next';

type ErrorDataLabelType = {
  error?: FetchBaseQueryError | SerializedError;
  retry?: () => void;
  retryCount?: number;
};
export const ErrorDataLabel = ({ error, retry, retryCount = 0 }: ErrorDataLabelType) => {
  const maxRetryCount = 3;
  return error && 'data' in error ? (
    <div
      role="alert"
      className="no-data rendered rendered-error flex h-full grow flex-col items-center justify-center gap-4 overflow-hidden"
    >
      <p className="custom-scroll overflow-auto px-5" style={{ color: 'red', whiteSpace: 'pre-wrap' }}>
        {String(getErrorLabel(error.data))}
      </p>
      {retry && retryCount < maxRetryCount && (
        <button onClick={retry}>
          <u>{`${t('tryAgain')}`}</u>
        </button>
      )}
      {retryCount === maxRetryCount && <p>{`${t('maxRetryReached')}`}</p>}
    </div>
  ) : (
    <div className="no-data rendered rendered-error w-full font-bold">
      <div className="flex h-full flex-col items-center justify-center">{String(t('anErrorOccurred'))}</div>
    </div>
  );
};

const getErrorLabel = (data: unknown) => {
  if (data === undefined || data === null || typeof data !== 'object') {
    return data;
  }
  return 'message' in data ? data.message : data;
};
